import * as global from "./shared/ktt-global.js";

window.viewQuery = global.viewQuery;
window.fm = global.fm;
window.config = {};
window.config.urls = global.urls;
window.config.files = global.files;
window.config.settings = global.settings;
window.config.unitType = global.unitType;
window.ui = global.ui;
window.regExes = global.regExes;
